import Vue from 'vue';
import accountService from '@/modules/account-service';
import Plan from '../models/plan';


const PLAN_REQUEST = 'PLAN_REQUEST',
	PLAN_SUCCESS = 'PLAN_SUCCESS',
	DISCOUNT_PLANS = 'DISCOUNT_PLANS',
	DISPLAY_PREPAID_PLAN = 'DISPLAY_PREPAID_PLAN',
	PLAN_ERROR = 'PLAN_ERROR',
	SET_PRODUCT = 'SET_PRODUCT',
	RESET_PLANS_STATE = 'RESET_PLANS_STATE';

const state = {
	status: {},
	product: '',
	plans: [],
	prepaidPlan: null,
	scopePlans: [],
	addOns: []
};

function filterByCategory(items, category) {
	return items.filter((item) => {
		return item.type === category;
	});
};

function filterOutName(items, category) {
	return items.filter((item) => {
		return item.name !== category;
	});
};

const getters = {
	product: state => state.product,
	plans: state => state.plans,
	intervalOptions: state => state.intervalOptions,
	scopePlans: state => state.scopePlans,
	prepaidPlan: state => state.prepaidPlan,
	planStatus: state => state.status,
	plansDiscounted: state => state.plans && state.plans.discounted
};

const actions = {
	[PLAN_REQUEST]: ({ commit, dispatch, rootGetters }, product) => {
		commit(PLAN_REQUEST);
		dispatch(SET_PRODUCT, product);
		accountService.getPlans(product)
			.then(response => {

				let plans = response.data.plans.map(Plan.fromDTO);

				plans.forEach(plan => {
					let displayFreeOption = plan.billingCyclesHash.monthly && plan.billingCyclesHash.free;
					if (displayFreeOption) {

						let freePlan = Object.assign({}, plan);
						freePlan.name += '[free]';

						freePlan.billingCycles = [freePlan.billingCyclesHash.free];

						freePlan.billingCyclesHash ={
							free: freePlan.billingCyclesHash.free
						};

						// delete plan.billingCyclesHash.free;
						plan.billingCycles = [plan.billingCyclesHash.monthly, plan.billingCyclesHash.yearly];
						delete plan.billingCyclesHash.free;

						plans.push(freePlan);
					}
				});
				commit(PLAN_SUCCESS, plans);
			})
			.catch(error => {
				commit(PLAN_ERROR);
			});
	},
	[SET_PRODUCT]: ({ commit, dispatch, rootGetters }, product) => {
		commit(SET_PRODUCT, product);
	},
	[DISCOUNT_PLANS]: ({ commit, dispatch, rootState }, payload) => {
		const coupon = payload;

		let couponIdsList = [];
		coupon.plans.forEach(plan => {
			plan.intervals.forEach(interval =>{
				couponIdsList.push(plan.name.toLowerCase().replace(/\ /g,'_') + '_' + interval);
			});
		});

		let plans = rootState.plans.slice(),
			discounted;

		plans.forEach((plan) => {
			plan.billingCycles.forEach(cycle => {
				if (couponIdsList.includes(cycle.intervalId)) {
					cycle.applyDiscount(coupon.discountPercentage);
					discounted = true;
				}
			});
		});

		if (discounted) {
			dispatch('APPLY_COUPON_CODE', coupon.id);
			commit(DISCOUNT_PLANS, plans);
		} else {
			dispatch('COUPON_DETAILS_ERROR', {type:'PLANS_NOT_SUPPORTED'});
		}

	},
	[DISPLAY_PREPAID_PLAN]: ({commit, dispatch, rootState}, payload) => {
		const coupon = payload;

		let plans = rootState.plans.slice(),
			plan = plans.find(plan => {
				return plan.name === coupon.plan;
			});

		const subcodePlan = Plan.createFromSubscriptionCode(plan, coupon);
		dispatch('APPLY_COUPON_CODE', coupon.id);
		commit(DISPLAY_PREPAID_PLAN, subcodePlan);
	},
	[RESET_PLANS_STATE]: ({ commit, dispatch }) => {
		if (getters.plansDiscounted(state)) {
			dispatch(PLAN_REQUEST);
		}
		commit(RESET_PLANS_STATE);
	}
};

const mutations = {
	[PLAN_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[PLAN_SUCCESS]: (state, plans) => {
		state.status = {
			success: true
		};


		Vue.set(state, 'plans', plans);

		state.plans.discounted = false;
	},
	[SET_PRODUCT]: (state, product) => {
		state.product = product;
	},
	[DISPLAY_PREPAID_PLAN]: (state, plan) => {
		Vue.set(state, 'prepaidPlan', plan);
	},
	[DISCOUNT_PLANS]: (state, plans) => {
		Vue.set(state, 'plans', plans);
		state.plans.discounted = true;
	},
	[PLAN_ERROR]: (state) => {
		state.status = {
			error: true
		};
	},
	[RESET_PLANS_STATE]: () => {
		state.status = {};
		state.plans.discounted = false;
	}
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/plan.js